import React, { useState, useEffect } from 'react';
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  Grid,
  Typography,
  Button,
  TablePagination,
  Checkbox,
  colors,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import Page from 'src/components/Page';
import Scrollbar from 'src/components/Scrollbar';
import SearchNotFound from 'src/components/SearchNotFound';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaCheck } from 'react-icons/fa';
import { IoIosCheckmark } from 'react-icons/io';
import palette from 'src/theme/palette';
import { CiSearch } from 'react-icons/ci';
import './../../styles/users.css';
import 'react-toastify/dist/ReactToastify.css';
import { useQuery } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import { studentService } from 'src/services/student.service';
import { classService } from 'src/services/class.service';
import { UserListHead } from 'src/sections/@dashboard/user';
import CustomPagination from 'src/components/CustomPagination';
import { SelectChangeEvent } from '@mui/material';
const TABLE_HEAD = [
  { id: 'StudentName', label: 'Student Name', alignRight: false },
  { id: '', label: '', alignRight: false },
  { id: 'Email', label: 'Email', alignRight: false },
  { id: 'Student ID', label: 'Student ID', alignRight: false },
  { id: 'Grade', label: 'Grade', alignRight: false },
];

export default function EnrolledStudents() {
  const navigate = useNavigate();
  const { classId } = useParams();
  const location = useLocation();
  const enrolledStudents = location.state?.enrolledStudents || [];

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState('');
  const [selectedGrade, setSelectedGrade] = useState<string>('');

  // Filter students based on search and grade
  const filteredStudents =
    enrolledStudents?.filter((student) => {
      const matchesSearch =
        !searchText ||
        student.user.firstname.toLowerCase().includes(searchText.toLowerCase()) ||
        student.user.lastname.toLowerCase().includes(searchText.toLowerCase()) ||
        student.user.email.toLowerCase().includes(searchText.toLowerCase());

      const matchesGrade = !selectedGrade || String(student.grade) === selectedGrade;

      return matchesSearch && matchesGrade;
    }) || [];

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
    setPage(0);
  };

  const handleGradeChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    console.log('Selected grade:', value);
    setSelectedGrade(value);
    setPage(0);
  };

  // Paginate the filtered students
  const paginatedStudents = filteredStudents.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const isUserNotFound = filteredStudents.length === 0;

  const queryClient = useQueryClient();
  const handleEnrollStudents = async () => {
    try {
      // await classService.enrollStudentsInClass(selectedStudents, classId);

      toast.success('Students enrolled successfully');
      // Invalidate the query to refetch class data
      // queryClient.invalidateQueries({ queryKey: ['classes'] });
      queryClient.invalidateQueries({ queryKey: ['class', classId] });
    } catch (error) {
      console.error('Failed to enroll students:', error);
      toast.error('Failed to enroll students');
    }
  };

  console.log(filteredStudents);
  return (
    <Page title="Users">
      <Container maxWidth={false}>
        <Card style={{ borderRadius: 16 }}>
          <Grid container spacing={2} justifyContent="space-between" style={{ padding: 20 }}>
            <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
              <div
                className="_login_row search_container"
                style={{ backgroundColor: palette.grey[400], borderRadius: 12 }}
              >
                <CiSearch size={24} color={palette.text.primary} />
                <input
                  type="text"
                  placeholder="Search by Name, Email or ID"
                  className="_auth_fields searchField"
                  value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            </Grid>
            <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
              <div className="_auth_fields">
                <FormControl fullWidth>
                  <InputLabel id="grade-select-label">Grade</InputLabel>
                  <Select
                    labelId="grade-select-label"
                    id="grade-select"
                    value={selectedGrade}
                    label="Grade"
                    onChange={handleGradeChange}
                  >
                    <MenuItem value="">All Grades</MenuItem>
                    {Array.from(new Set(enrolledStudents.map((student) => student.grade)))
                      .sort((a, b) => Number(a) - Number(b))
                      .map((grade) => (
                        <MenuItem key={grade} value={String(grade)}>
                          Grade {grade}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
            </Grid>
          </Grid>
          <Scrollbar>
            <TableContainer>
              <Table>
                <UserListHead headLabel={TABLE_HEAD} rowCount={filteredStudents.length} />
                <TableBody>
                  {paginatedStudents?.map((student) => {
                    const { id, grade, user } = student;
                    return (
                      <TableRow hover key={id}>
                        <TableCell scope="row">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography color="#111827" variant="subtitle1">
                              {user?.firstname} {user?.lastname}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell>
                          {/* <img
                            src={badge?.imageUrl}
                            alt={badge?.name}
                            style={{ width: 40, height: 40, borderRadius: '50%' }}
                          /> */}
                        </TableCell>
                        <TableCell align="left">
                          <Typography variant="subtitle1">{user?.email}</Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography variant="subtitle1">{user?.extendedproperties?.studentId}</Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography variant="subtitle1">{grade ?? '--'}</Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6}>
                        <SearchNotFound searchQuery={searchText} sx={{ boxShadow: 'none' }} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredStudents.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Scrollbar>
        </Card>
      </Container>
    </Page>
  );
}
